/**
 * Определяет путь редиректа на основе роли пользователя
 * @param {string} role - Роль пользователя
 * @returns {string} - Путь для редиректа
 */
export const getDefaultRedirectPath = (role) => {
  if (!role) {
    return '/users';
  }

  const roleToPathMap = {
    'smm_manager': '/mailings',
    // Другие роли редиректятся на /users по умолчанию
  };

  return roleToPathMap[role] || '/users';
};
